import React, { useEffect, useState, useContext, useRef } from 'react';
import { Carrossel } from '../../Components/Carrossel';
import FastAccesses from '../../Components/FastAccesses';
import MinhaObra from '../../Components/MinhaObra';
import Destaques from '../../Components/Destaques';
import BaseComponentInternas from '../../Components/BaseComponentInternas';
import { Spinner } from '../../Components/StyledComponent';
import EmptyState from '../../Components/MinhaObra/EmptyState';
import NoPicturesImageSrc from '../../assets/novosicones/minha-obra/NoPictures.svg';
import Fade from '@material-ui/core/Fade';
import BannerHome from '../../Components/BannerHome';
import { ContextGetData } from '../../services/getData';
import { ContextoListaApartamentos } from '../../Components/ApartamentList/contextoImoveis';
import { ContextNotificacoes } from '../../services/notificacoes';

import SatisfactionSurvey from '../../Components/SatisfactionSurvey';
import ModalInformativoRenegociacao from '../../Components/ModalInformativoRenegociacao';

import './styles.scss';
import { ContextRenegociacao } from '../../services/renegociacao';
import IndicaMais from '../../Components/IndicaMais';

const Interna = () => {
  const {
    contratosRenegociacao,
    buscaDados,
    imagensEmpreendimento,
    statusObra,
    loadHomeInicial,
    home,
  } = useContext(ContextGetData);

  const { imovelAtual, tema, executarScroll, setExecutarScroll } = useContext(
    ContextoListaApartamentos
  );

  const { surveyModal, setSurveyModal } = useContext(ContextNotificacoes);

  const { loadNotificacoes } = useContext(ContextNotificacoes);

  const [loadingChangeEmpreendimento, setLoadingChangeEmpreendimento] =
    useState(true);

  const {
    showModalInformativoRenegociacao,
    setShowModalInformativoRenegociacao,
    modalInformativoRenegociacaoExibido,
    setModalInformativoRenegociacaoExibido,
  } = useContext(ContextRenegociacao);

  useEffect(() => {
    const load = async () => {
      try {
        await loadNotificacoes();
        //só chama o loadHomeInicial se não tiver imóveis
        if (!home.length > 0) {
          await loadHomeInicial();
        }
      } catch (e) {
        console.error(e);
      } finally {
        setLoadingChangeEmpreendimento(false);
      }
    };
    load();
  }, []);

  useEffect(() => {
    const load = async () => {
      await loadHome(imovelAtual.assetId);
    };

    if (imovelAtual.assetId) {
      load().catch((e) => {
        console.error('load home inicial', e);
      });
    }
  }, [imovelAtual.assetId]);

  useEffect(() => {
    const hasContratosRenegociacao = contratosRenegociacao?.length > 0;

    if (hasContratosRenegociacao && !modalInformativoRenegociacaoExibido) {
      setShowModalInformativoRenegociacao(true);
      setModalInformativoRenegociacaoExibido(true);
    }
  }, [contratosRenegociacao]);

  const refFotosObra = useRef(null);
  const executeScroll = () => refFotosObra?.current?.scrollIntoView();

  if (executarScroll) {
    executeScroll();
    setExecutarScroll(false);
  }

  // id é assetIdSalesFoce
  async function loadHome(id) {
    await buscaDados(id);
    setLoadingChangeEmpreendimento(false);
  }

  const handleCloseModals = () => {
    setSurveyModal(false);
  };

  //caso já tenha carregado os estados é autorizado o carregamento da home
  if (loadingChangeEmpreendimento) {
    return (
      <div style={{ width: '100%', height: '100vh' }} className='centralized'>
        <Spinner />
      </div>
    );
  }

  return (
    <BaseComponentInternas>
      <FastAccesses />

      {showModalInformativoRenegociacao && (
        <ModalInformativoRenegociacao
          setShowModalInformativoRenegociacao={
            setShowModalInformativoRenegociacao
          }
          tema={tema}
        />
      )}

      {loadingChangeEmpreendimento ? (
        <Spinner />
      ) : (
        <>
          <BannerHome tema={tema} />
          <Fade in>
            <div>
              {imagensEmpreendimento === undefined ||
              imagensEmpreendimento.length === 0 ||
              imagensEmpreendimento[0] === '' ? (
                <div className='obra-carrossel centralized-space-between'>
                  <MinhaObra status={statusObra} />
                  <div className='centralized obra-carrossel__semImagem'>
                    <EmptyState
                      tema={tema}
                      imageSrc={NoPicturesImageSrc}
                      title='Assim que a obra avançar você verá as fotos dela aqui'
                      text='As fotos vão aparecer aqui, quando isso acontecer você será notificado.'
                    />
                  </div>
                </div>
              ) : (
                <div
                  className='obra-carrossel centralized-space-between'
                  ref={refFotosObra}
                >
                  <MinhaObra status={statusObra} />

                  <Carrossel />
                </div>
              )}
            </div>
          </Fade>
        </>
      )}
      <SatisfactionSurvey
        open={surveyModal ?? false}
        close={handleCloseModals}
        home
      />
      <IndicaMais />
      <Destaques tema={tema} />
    </BaseComponentInternas>
  );
};

export default Interna;
